"use strict"

// scroll events

const header = document.getElementById('header');
const logo = document.getElementById('logo');

// home
const homePhilosophy = document.getElementById('homePhilosophy');
const homeShop = document.getElementById('homeShop');
const homeCandles = document.getElementById('homeCandles');
const homeHanano = document.getElementById('homeHanano');
const homeByyourside = document.getElementById('homeByyourside');

// philosophy
const philosophyImg = document.querySelector('#philosophyTxt figure');

function scrollEvents($noAnime) {
  let scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
  let winHeight = document.documentElement.clientHeight || document.body.clientHeight;
  if (logo) {
    let logoRect = logo.getBoundingClientRect();
    let logoTop = logoRect.top + scrollTop;
  }
  
  if (header) {
    if((winHeight / 5) <= scrollTop || document.body.getAttribute('id') != 'home') {
      header.classList.add('scroll');
    } else {
      header.classList.remove('scroll');
    }
  }
	
	// home philosophy
	if(homePhilosophy) {
		let homePhilosophyImg = homePhilosophy.querySelector('figure')
    let homePhilosophyImgRect = homePhilosophyImg.getBoundingClientRect();
    let homePhilosophyImgTop = homePhilosophyImgRect.top + scrollTop;
    
    if(homePhilosophyImgTop + homePhilosophyImg.offsetHeight / 3  <= scrollTop + winHeight) {
       homePhilosophyImg.classList.add('disp');
    }
	}
	
	//home shop
	if(homeShop) {
    let homeShopRect = homeShop.getBoundingClientRect();
    let homeShopTop = homeShopRect.top + scrollTop;
    
    if(homeShopTop + homeShop.offsetHeight / 2 <= scrollTop + winHeight) {
       homeShop.classList.add('disp');
    }
		
	}
	
	//home Candles
	if(homeCandles) {
    let homeCandleRect = homeCandles.getBoundingClientRect();
    let homeCandlessideTop = homeCandleRect.top + scrollTop;
    
    if(homeCandlessideTop + homeCandles.offsetHeight / 3 <= scrollTop + winHeight) {
       homeCandles.classList.add('disp');
    }
		
	}
	
	//home by your side
	if(homeHanano) {
    let homeHananoRect = homeHanano.getBoundingClientRect();
    let homeHananoTop = homeHananoRect.top + scrollTop;
    
    if(homeHananoTop + homeHanano.offsetHeight / 3 <= scrollTop + winHeight) {
       homeHanano.classList.add('disp');
    }
		
	}
	
	//home by your side
	if(homeByyourside) {
    let homeByyoursideRect = homeByyourside.getBoundingClientRect();
    let homeByyoursideTop = homeByyoursideRect.top + scrollTop;
    
    if(homeByyoursideTop + homeByyourside.offsetHeight / 3 <= scrollTop + winHeight) {
       homeByyourside.classList.add('disp');
    }
		
	}
	
	// philosophy img
	if(philosophyImg) {
		
    let philosophyImgRect = philosophyImg.getBoundingClientRect();
    let philosophyImgTop = philosophyImgRect.top + scrollTop;
    
		if(philosophyImgTop + philosophyImg.offsetHeight / 10 <= scrollTop + winHeight) {
			philosophyImg.classList.add('disp');
		}
	}
}


// gnav toggle

const gNav = document.getElementById('gNav');
const gNavBtn = document.getElementById('gNavBtn');

if(gNavBtn && gNav) {
  gNavBtn.addEventListener('click', function() {
    if(header) header.classList.toggle('open');
    gNav.classList.toggle('open');
    gNavBtn.classList.toggle('open');
  });
}


// item list

const itemList = document.querySelectorAll('.itemList li');

function itemDisp() {
  const items = itemList.length ? itemList : document.querySelectorAll('.itemList li');
  for(let i = 0; i < items.length; i++) {
    items[i].classList.add('disp');
  }
}

//item detail

function initItemDetail() {
  const itemDetail = document.getElementById('itemDetail');
  if(!itemDetail) return;
  if(document.getElementById('imgViewer')) return;

  const imgs  = itemDetail.querySelector('#itemImgs .imgs');
  let current = 0;
  if(imgs && imgs.children.length) {
    
    // ビュアー生成
    const imgView = document.createElement('figure');
    imgView.id = 'imgViewer';
    const firstImg = imgs.children[current].querySelector('img');
    if(firstImg) {
      imgView.appendChild(firstImg.cloneNode());
    }
    imgs.parentNode.insertBefore(imgView, imgs);
    
    // ナビ生成
    const imgNav = document.createElement('ul');
    imgNav.id = 'imgNav';
    imgs.parentNode.insertBefore(imgNav, imgs.nextElementSibling);
    
    imgs.children[current].classList.add('current');  //  PC current
    imgs.setAttribute('data-current',current);  // sp current
  
    for(let i = 0; i < imgs.children.length; i++) {
      
      imgs.children[i].addEventListener('click', function(){
        if(!imgView.classList.contains('slide')) {
          imgs.children[current].classList.remove('current');
          imgNav.children[current].classList.remove('current');
          if(this.dataset.type=="image") {
            const targetImg = this.querySelector('img');
            if(targetImg) imgView.appendChild(targetImg.cloneNode());
          } else if(this.dataset.type=="video") {
            const htmlString = this.dataset.videotag;
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = htmlString;
            const decodedHtml = tempDiv.innerHTML;
            const container = document.createElement('div');
            container.innerHTML = decodedHtml;
            const videoElement = container.firstChild;
            if(videoElement) {
              videoElement.controls = true;
              videoElement.autoplay = true;
              videoElement.muted = true;
              imgView.appendChild(videoElement);
            }
          }
          const cloneThumb = this.querySelector('img');
          if(cloneThumb) this.appendChild(cloneThumb.cloneNode());
          setTimeout(function() {
            current = i;
            imgView.classList.add('slide');
            imgs.children[i].classList.add('current');  //  PC current
            imgs.setAttribute('data-current',i);  // sp current
            imgNav.children[i].classList.add('current');
            setTimeout(function() {
              imgs.children[i].classList.add('slide');
            }, 100);
          }, 100);
          setTimeout(function() {
            if(imgView.firstElementChild) imgView.firstElementChild.remove();
            const thumbs = imgs.children[i].querySelectorAll('img');
            if(thumbs.length > 1) thumbs[0].remove();
            imgView.classList.remove('slide');
            imgs.children[i].classList.remove('slide');
          }, 700);
        }
        
      });
      
      // ナビボタン設定
      const imgNavBtn = document.createElement('li');
      imgNavBtn.addEventListener('click', function(){
        imgs.children[current].classList.remove('current');
        imgNav.children[current].classList.remove('current');
        current = i;
        imgs.children[i].classList.add('current');  //  PC current
        imgs.setAttribute('data-current',i);  // sp current
        imgNav.children[i].classList.add('current');
      });
      imgNav.appendChild(imgNavBtn);
    }
    
    if(imgNav.children[current]) imgNav.children[current].classList.add('current');
    
    let startX, startY;
    let moveX, moveY;	// スワイプ中の xy座標
    let dist = 30;	// スワイプを感知する最低距離（ピクセル単位）

    // タッチ開始時： xy座標を取得
    imgs.addEventListener("touchstart", function(e) {
      if(e.touches && e.touches[0]) {
        startX = e.touches[0].pageX;
        startY = e.touches[0].pageY;
      }
    });

    // スワイプ中： xy座標を取得
    imgs.addEventListener("touchmove", function(e) {
      if(!e.changedTouches || !e.changedTouches[0]) return;
      moveX = e.changedTouches[0].pageX;
      moveY = e.changedTouches[0].pageY;
      let diffX = Math.abs(startX - moveX);
      let diffY = Math.abs(startY - moveY);
      if (diffY > diffX || diffX < dist) {
        return;
      }
      e.preventDefault();
    });

    imgs.addEventListener("touchend", function() {
      if(startX === undefined || moveX === undefined) return;
      imgs.children[current].classList.remove('current');
      if(imgNav.children[current]) imgNav.children[current].classList.remove('current');

      if(imgs.children[current].dataset.type=='video') {
        let video = imgs.children[current].querySelector('video');
        if(video) {
          video.pause();
          video.currentTime = 0;
        }
      }
      
      if (startX > moveX && startX > moveX + dist) {
        if(current < imgs.children.length - 1) {
          current++;
        }
      } else if (startX < moveX && startX + dist < moveX) {
        if(current > 0) {
          current--;
        }
      }
      imgs.children[current].classList.add('current');  //  PC current
      imgs.setAttribute('data-current',current);  // sp current
      if(imgNav.children[current]) imgNav.children[current].classList.add('current');
      
      if(imgs.children[current].dataset.type=='video') {
        let video = imgs.children[current].querySelector('video');
        if(video) {
          video.play();
          video.autoplay = true;
          video.muted = true;
          video.controls = true;
        }
      }
    });
  }
}

if(document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initItemDetail);
} else {
  initItemDetail();
}


// agree

const agree = document.getElementById('agree');

if(agree) {
 agree.addEventListener('click', function(){
   document.querySelector('.shopify-buy-frame').setAttribute('data-agree',1);
   this.classList.add('ok');
 });
}


// hidden box

const hiddenBoxLink = document.querySelectorAll('[data-hiddenboxlink="1"]');
const hiddenBox = document.getElementsByClassName('hiddenBox');

if(hiddenBoxLink && hiddenBox) {
	
	for(let i = 0; i < hiddenBoxLink.length; i++) {
		hiddenBoxLink[i].onclick = function() {
			for(let j = 0; j < hiddenBox.length; j++) {
				hiddenBox[j].style.display = 'none';
			}
			document.getElementById(this.getAttribute('href').replace('#', '')).style.display = 'block';
		}
	}
}


// Display/Styling

const stylingCases = document.getElementsByClassName('stylingCases');

if(stylingCases.length) {
   
  const stylingCasesImgs = stylingCases[0].children;
  
	for(let i = 0; i < stylingCasesImgs.length; i++) {
		stylingCasesImgs[i].onclick = function() {
    }
    
  }
}


// windwo events

window.addEventListener( 'scroll', function() {
  scrollEvents();
  itemDisp();
});
window.addEventListener( 'resize', function() {
  scrollEvents();
  itemDisp();
});
window.addEventListener( 'load', function() {
  scrollEvents();
  itemDisp();

  // newsletter
  const params = (new URL(document.location)).searchParams;
  if(params.get('customer_posted')=='true') {
    window.scrollTo({
      top: 10000,
      left: 0,
      behavior: 'smooth'
    });
    window.location.hash = 'shopify-section-16167450847c754e71';
  }
  
  document.body.classList.add('loaded');
});